// react
// navigate
import { createSlice } from '@reduxjs/toolkit';
// formik
// @material-ui
// icons
// hooks
// @types
import { AxiosResponseModel } from '../../@types/base';
// redux
import { CONSTS } from './const';
import { dispatch } from '../store';
// routes
// components
// utils
import axios from '../../utils/axios';
// constants
import { HttpStatusCodes } from '../../constants/http-status-codes.enum';
import {
  FaceSearchListModel,
  FaceSearchResultModel,
  FaceSearchDetailModel,
  FaceSearchWithValueModel
} from '../../@types/faceSearch';

// ----------------------------------------------------------------------

type FaceSearchState = {
  faceSearchError: boolean;
  isFaceSearchLoading: boolean;
  faceSearchList: FaceSearchListModel[];

  isFaceSearchDetailLoading: boolean;
  createFaceSearchModalIsOpen: boolean;
  updateFaceSearchModalIsOpen: boolean;

  searchDocumentFile: File | null;
  searchDocumentFormData: FormData | null;

  faceSearchDetail: FaceSearchDetailModel;
};

const faceSearchDetailInit: FaceSearchDetailModel = {
  id: '',
  name: '',
  ipAddress: '',
  aiId: null,
  companyId: 0,
  image: '',
  locationId: null
};

const initialState: FaceSearchState = {
  faceSearchError: false,
  isFaceSearchLoading: false,
  faceSearchList: [],

  isFaceSearchDetailLoading: false,
  createFaceSearchModalIsOpen: false,
  updateFaceSearchModalIsOpen: false,

  searchDocumentFile: null,
  searchDocumentFormData: null,

  faceSearchDetail: faceSearchDetailInit
};

const slice = createSlice({
  name: 'faceSearch',
  initialState,
  reducers: {
    // ----------------------------------------------------------------------
    // FACESEARCH
    // ----------------------------------------------------------------------

    // START FACESEARCH LOADING
    startFaceSearchLoading(state) {
      state.isFaceSearchLoading = true;
    },

    // HAS ERROR FACESEARCH
    hasErrorFaceSearch(state, action) {
      state.isFaceSearchLoading = false;
      state.faceSearchError = action.payload;
    },

    // GET ALL FACESEARCH
    getAllFaceSearchSuccess(state, action) {
      state.isFaceSearchLoading = false;
      state.faceSearchList = action.payload;
    },

    // START FACESEARCH
    startFaceSearchDetailLoading(state) {
      state.isFaceSearchDetailLoading = true;
    },

    // GET FACESEARCH DETAIL
    getFaceSearchDetailByIdSuccess(state, action) {
      state.isFaceSearchDetailLoading = false;
      state.faceSearchDetail = action.payload;
    },

    // FACESEARCH DETAIL MODAL OPEN
    onToggleUpdateFaceSearchOpenModal(state, action) {
      state.updateFaceSearchModalIsOpen = action.payload;
    },

    // SET FACE SEARCH FILES
    onChangeFileForsearchDocumentMethod(state, action) {
      state.searchDocumentFile = action.payload;
    },

    // SET FACE SEARCH FILES FORMDATA
    onChangeFormDataForsearchDocumentMethod(state, action) {
      state.searchDocumentFormData = action.payload;
    },

  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  onToggleUpdateFaceSearchOpenModal,
  onChangeFileForsearchDocumentMethod,
  onChangeFormDataForsearchDocumentMethod
} = slice.actions;

// ----------------------------------------------------------------------
// FACESEARCH

export async function getAllFaceSearchWithReturn(
  limit: number,
  offset: number
) {
  dispatch(slice.actions.startFaceSearchLoading());
  try {
    // if (startDate.includes('T')) {
    //   startDate = startDate.slice(0, startDate.indexOf('T'));
    // }
    // if (endDate.includes('T')) {
    //   endDate = endDate.slice(0, endDate.indexOf('T'));
    // }
    const response: AxiosResponseModel<FaceSearchResultModel> = await axios
      .get(
        `${CONSTS.FACESEARCH_GET_GET_ALL_FACESEARCH}?limit=${limit}&offset=${offset}`
      )
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(slice.actions.getAllFaceSearchSuccess(response.data?.data));
    } else {
      dispatch(slice.actions.getAllFaceSearchSuccess([]));
    }
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorFaceSearch(error));
    return error.response.data;
  }
}

export function getFaceSearchById(faceSearchId: string) {
  return async () => {
    dispatch(slice.actions.startFaceSearchDetailLoading());
    // dispatch(slice.actions.startDetailLoading());
    try {
      const response: AxiosResponseModel<FaceSearchDetailModel> = await axios
        .get(`${CONSTS.FACESEARCH_GET_GET_FACESEARCH}/${faceSearchId}`)
        .catch((error) => {
          if (error.response) {
            return error.response.data;
          }
          return error;
        });
      if (response && response.status === HttpStatusCodes.StatusSuccess) {
        dispatch(
          slice.actions.getFaceSearchDetailByIdSuccess(
            response.data?.data || faceSearchDetailInit
          )
        );
      } else {
        dispatch(
          slice.actions.getFaceSearchDetailByIdSuccess(faceSearchDetailInit)
        );
      }
    } catch (error: any) {
      dispatch(slice.actions.hasErrorFaceSearch(error));
    }
  };
}

export async function getFaceSearchByIdWithReturn(faceSearchId: string) {
  dispatch(slice.actions.startFaceSearchDetailLoading());
  // dispatch(slice.actions.startDetailLoading());
  try {
    const response: AxiosResponseModel<FaceSearchDetailModel> = await axios
      .get(`${CONSTS.FACESEARCH_GET_GET_FACESEARCH}/${faceSearchId}`)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(
        slice.actions.getFaceSearchDetailByIdSuccess(
          response.data?.data || faceSearchDetailInit
        )
      );
    } else {
      dispatch(
        slice.actions.getFaceSearchDetailByIdSuccess(faceSearchDetailInit)
      );
    }
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorFaceSearch(error));
    return error.response.data;
  }
}

export async function testzip(model: any) {
  try {
    const response: AxiosResponseModel<null> = await axios
      .post(`export/export`, model)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    // if (response && response.statusCode === HttpStatusCodes.StatusSuccess) {
    // dispatch(slice.actions.hasError(false));

    // dispatch(slice.actions.hasError(response.message));
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorFaceSearch(error));
    return error.response.data;
  }
}

export async function faceSearchWithValues(
  faceSearchModel: FaceSearchWithValueModel
) {
  dispatch(slice.actions.startFaceSearchLoading());
  try {
    const response: AxiosResponseModel<FaceSearchResultModel> = await axios
      .post(CONSTS.FACESEARCH_POST_SEARCH_FACESEARCH, faceSearchModel)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      // await getAllFaceSearchWithReturn('', '');
      // dispatch(slice.actions.getAllFaceSearchSuccess(response.data?.data));
      dispatch(slice.actions.hasErrorFaceSearch(false));
    } else {
      // dispatch(slice.actions.getAllFaceSearchSuccess([]));
      dispatch(slice.actions.hasErrorFaceSearch(response.data?.message || ''));
    }
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorFaceSearch(error));
    return error.response.data;
  }
}

export async function updateFaceSearchWithReturn(
  updateFaceSearch: FaceSearchDetailModel
) {
  try {
    const response: AxiosResponseModel<null> = await axios
      .post(
        `${CONSTS.FACESEARCH_POST_EDIT_FACESEARCH}/${updateFaceSearch.id}`,
        updateFaceSearch
      )
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    // if (response && response.statusCode === HttpStatusCodes.StatusSuccess) {
    // dispatch(slice.actions.hasError(false));

    // dispatch(slice.actions.hasError(response.message));
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorFaceSearch(error));
    return error.response.data;
  }
}

export async function deleteFaceSearchWithReturn(faceSearchIds: string[]) {
  // dispatch(slice.actions.startCompanyLoading());
  try {
    const response: AxiosResponseModel<null> = await axios
      .post(`${CONSTS.FACESEARCH_POST_DELETE_FACESEARCH}/${faceSearchIds[0]}`)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorFaceSearch(error));
    return error.response.data;
  }
}

// ----------------------------------------------------------------------
